module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "mt-0"
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "offset-sm3": ""
    }
  }, [_c('h4', [_vm._v("Create a new Location")])])], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "offset-sm3": ""
    }
  }, [_c('form', {
    attrs: {
      "action": ""
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onCreateLocation($event)
      }
    }
  }, [_c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "name": "locationName",
      "label": "Name",
      "id": "locationName",
      "single-line": "",
      "required": ""
    },
    model: {
      value: (_vm.locationName),
      callback: function($$v) {
        _vm.locationName = $$v
      },
      expression: "locationName"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "name": "locationStreetAddress",
      "label": "Stree Address",
      "id": "locationStreetAddress",
      "single-line": "",
      "required": ""
    },
    model: {
      value: (_vm.locationStreetAddress),
      callback: function($$v) {
        _vm.locationStreetAddress = $$v
      },
      expression: "locationStreetAddress"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "name": "locationCity",
      "label": "City",
      "id": "locationCity",
      "single-line": "",
      "required": ""
    },
    model: {
      value: (_vm.locationCity),
      callback: function($$v) {
        _vm.locationCity = $$v
      },
      expression: "locationCity"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "name": "locationState",
      "label": "State",
      "id": "locationState",
      "single-line": "",
      "required": ""
    },
    model: {
      value: (_vm.locationState),
      callback: function($$v) {
        _vm.locationState = $$v
      },
      expression: "locationState"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "name": "locationZipcode",
      "label": "Zipcode",
      "id": "locationZipcode",
      "single-line": "",
      "required": ""
    },
    model: {
      value: (_vm.locationZipcode),
      callback: function($$v) {
        _vm.locationZipcode = $$v
      },
      expression: "locationZipcode"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-btn', {
    staticClass: "primary",
    attrs: {
      "disabled": !_vm.formIsValid,
      "type": "submit"
    }
  }, [_vm._v("\n              Create Location\n            ")])], 1)], 1)], 1)])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6132d15c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Locations/CreateLocation.vue
// module id = 688
// module chunks = 1